<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("edit")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input 
      :label="$t('promocode')" 
      type="text" 
      v-model="promocode" 
      />
      <mdb-input
        :label="$t('product_google')"
        type="text"
        v-model="product_google"
      />
      <mdb-input
        :label="$t('product_apple')"
        type="text"
        v-model="product_apple"
      />
      <mdb-input
        :label="$t('duration')"
        type="text"
        v-model="duration"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="saveEditPromoCode" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon
} from "mdbvue";
export default {
  name: "EditPromoCode",
  props: {
    modalShow: Boolean,
    addPromoCodeState: Boolean,
    promocode: String,
    product_google: String,
    product_apple: String,
    duration: String,
    id: Number,
    description: String,
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon
  },
  data() {
    return {
      promocodepath: "/1.0/front/promocode",
    };
  },
  methods: {
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    saveEditPromoCode() {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        promocode: this.promocode,
        product_google: this.product_google,
        product_apple: this.product_apple,
        duration: this.duration,
        id: this.id,
      });
      this.$http
        .post(this.promocodepath, this.postdata)
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_promocode_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          }
          this.$emit("modal-ok");
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("adding_promocode_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  }
};
</script>

<style scoped></style>
